module.exports = __webpack_public_path__ + "static/media/model3.6cbdd7f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model3.jpg
// module id = 497
// module chunks = 33